// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 164 ? "chart" : chunkId) + ".bundle.2572b6d5b3d265d273e43b736b37daefbc4f629e.js";
};